export const COOKIE_VERSION = 'v2';
export const COOKIE_VERSION_KEY = 'rafiki_cookie_version';
